import React from 'react';
import { Redirect } from 'react-router-dom'; 
import Product from '../components/Product/';



 

const Page = ({   history, isAuthenticated, match }) => {
    if (!isAuthenticated) return <Redirect to="/login" />
 
    return (
        <div className="Product">  
             <Product history={history} match={ match }   />
        </div>
    );
}

 


export default Page;